module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('strong', [_vm._v("Table of Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfront"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/intro#intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "tocauthor"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("BY RICHARD GRISWOLD DEL CASTILLO")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01"
    }
  }, [_vm._v("1. Mexican Americans in 1940: Perceptions and Conditions")])]), _vm._v(" "), _c('p', {
    staticClass: "tocauthor"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("BY RICHARD STEELE")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02"
    }
  }, [_vm._v("2. The Federal Government Discovers Mexican Americans")])]), _vm._v(" "), _c('p', {
    staticClass: "tocauthor"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("BY RICHARD STEELE")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Violence in Los Angeles: Sleepy Lagoon, the Zoot-Suit Riots, and the Liberal Response")])]), _vm._v(" "), _c('p', {
    staticClass: "tocauthor"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("BY RICHARD STEELE")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. The War and Changing Identities: Personal Transformations")])]), _vm._v(" "), _c('p', {
    staticClass: "tocauthor"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("BY RICHARD GRISWOLD DEL CASTILLO")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Civil Rights on the Home Front: Leaders and Organizations")])]), _vm._v(" "), _c('p', {
    staticClass: "tocauthor"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("BY RICHARD GRISWOLD DEL CASTILLO")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/epilogue#epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue: Civil Rights and the Legacy of War")])]), _vm._v(" "), _c('p', {
    staticClass: "tocauthor"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("BY RICHARD STEELE AND RICHARD GRISWOLD DEL CASTILLO")])]), _vm._v(" "), _c('p', {
    staticClass: "tocback"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/appendixa#appendixa",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix A: Ruth Tuck, “The Minority Citizen”")])]), _vm._v(" "), _c('p', {
    staticClass: "tocback"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/appendixb#appendixb",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix B: Statement of Carlos E. Castañeda before the U.S. Senate Regarding the Need for a Fair Employment Practices Commission, March 12, 1945")])]), _vm._v(" "), _c('p', {
    staticClass: "tocback"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/appendixc#appendixc",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix C: Executive Order 8802 Establishing the Fair Employment Practices Committee, June 25, 1941")])]), _vm._v(" "), _c('p', {
    staticClass: "tocback"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/appendixd#appendixd",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix D: The “Caucasian Race—Equal Privileges” Texas House Concurrent Resolution, 1943")])]), _vm._v(" "), _c('p', {
    staticClass: "tocback"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/appendixe#appendixe",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix E: Manuel Ruiz, “Latin-American Juvenile Delinquency in Los Angeles: Bomb or Bubble!”")])]), _vm._v(" "), _c('p', {
    staticClass: "tocback"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/appendixf#appendixf",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix F: Raul Morin, excerpts from "), _c('em', [_vm._v("Among the Valiant: Mexican-Americans in WW II and Korea")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocback"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/appendixg#appendixg",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix G: Affidavits of Mexican Americans Regarding Discrimination in Texas during World War II (Collected by Alonso S. Perales)")])]), _vm._v(" "), _c('p', {
    staticClass: "tocback1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "tocback1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/bibliography#bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Selected Annotated Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "tocback1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/index#index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 72
// module chunks = 0